import { useEffect, useState } from 'react'

const useLocale = (instanceId?: string): string => {
  const [current, setCurrent] = useState<string>('fr-FR')

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_locale', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_locale'))

    return () => {
      document.removeEventListener('retorik_locale', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useLocale
